module.exports = __webpack_public_path__ + "img/not-eval-assess.652a3f58.svg";